import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useEffect } from "react";
import { Row, Col, FormGroup, Button, Container } from "react-bootstrap";
import { BsChevronDown } from "react-icons/bs";
import { GoCalendar } from "react-icons/go";
import { AiTwotoneCalendar, AiOutlineClockCircle } from "react-icons/ai";
import { BiCalendarAlt, BiChevronDown } from "react-icons/bi";
import TimePicker from "./TimePicker";
import DatePicker from "react-datepicker";
import moment from "moment";
import "react-datepicker/dist/react-datepicker.css";
import operations from "../../../ducks/cart/operations";
import MediaQuery from "react-responsive";
import { TravelButton } from "../Travel";
import leadtimeVectorImg from "../../../images/leadtime-vector.png";
export var TimingOptions = function TimingOptions(props) {
  var _props$isCater = props.isCater,
      isCater = _props$isCater === void 0 ? false : _props$isCater,
      _props$leadTime = props.leadTime,
      leadTime = _props$leadTime === void 0 ? "45" : _props$leadTime,
      _props$title = props.title,
      title = _props$title === void 0 ? "title" : _props$title,
      _props$setFieldValue = props.setFieldValue,
      setFieldValue = _props$setFieldValue === void 0 ? function () {
    return "";
  } : _props$setFieldValue,
      deleteField = props.deleteField,
      index = props.index,
      _props$location = props.location,
      location = _props$location === void 0 ? {} : _props$location,
      _props$leadtimeErr = props.leadtimeErr,
      leadtimeErr = _props$leadtimeErr === void 0 ? "" : _props$leadtimeErr;

  var _useState = useState(""),
      _useState2 = _slicedToArray(_useState, 2),
      time = _useState2[0],
      setTimeCheck = _useState2[1];

  var _useState3 = useState(),
      _useState4 = _slicedToArray(_useState3, 2),
      date = _useState4[0],
      setDate = _useState4[1];

  var _useState5 = useState(""),
      _useState6 = _slicedToArray(_useState5, 2),
      dueTime = _useState6[0],
      setDueTime = _useState6[1];

  var _useState7 = useState(""),
      _useState8 = _slicedToArray(_useState7, 2),
      start = _useState8[0],
      setStart = _useState8[1];

  var _useState9 = useState([]),
      _useState10 = _slicedToArray(_useState9, 2),
      exclude = _useState10[0],
      setExclude = _useState10[1];

  var _useState11 = useState(false),
      _useState12 = _slicedToArray(_useState11, 2),
      showLeadtimeErr = _useState12[0],
      setLeadTimeErr = _useState12[1];

  var objName = title.toLowerCase();
  var format2 = "YYYY-MM-DD";
  var todaysDate = new Date();
  var formattedToday = moment(todaysDate).format(format2);
  var nowPlus30 = moment(todaysDate).add(leadTime, "minutes").roundNext15Min().format("HH:mm");
  var tomorrowsDate = moment(todaysDate).add(1, 'day'); // getting the store close time for day of the week

  var todayCloseingTime = location ? location[moment().format('dddd') + 'Close'] : "";
  var todayOpeningTime = location ? location[moment().format('dddd') + 'Open'] : "";
  var tomorrowOpeningTime = location ? location[tomorrowsDate.format('dddd') + 'Open'] : ""; // get times for now, when store opens, and store closes

  var storeOpen = todayOpeningTime ? moment(todayOpeningTime, ["h:mm A"]).format('HH:mm') : "";
  var storeClose = todayCloseingTime ? moment(todayCloseingTime, ["h:mm A"]).format("HH:mm") : "";
  var nextdayStoreOpen = tomorrowOpeningTime ? moment(tomorrowOpeningTime, ["h:mm A"]).format("HH:mm") : "";
  var now = moment().format("HH:mm");

  var handleOptionChange = function handleOptionChange(changeEvent) {
    var _changeEvent$target;

    if ((_changeEvent$target = changeEvent.target) === null || _changeEvent$target === void 0 ? void 0 : _changeEvent$target.value) {
      var value = changeEvent.target.value.toLowerCase();
      setFieldValue(objName + "Time", value);
      return setTimeCheck(value);
    } else {
      setFieldValue(objName + "Time", changeEvent);
      return setTimeCheck(changeEvent);
    }
  };

  useEffect(function () {
    if (leadtimeErr != "") {
      setLeadTimeErr(true);
    } else {
      setLeadTimeErr(false);
    }
  }, [leadtimeErr]);
  useEffect(function () {
    if (isCater) {
      handleOptionChange("scheduled");
    } else {
      if (!btnsAfterClose(now)) {
        handleOptionChange("asap");
      } else {
        handleOptionChange("scheduled");

        if (storeClose !== "" && !moment(now, ['HH:mm']).isSameOrBefore(moment(storeClose, ["h:mm A"]).subtract(21, 'minutes'))) {
          var tomorrow = new Date();
          tomorrow.setDate(todaysDate.getDate() + 1);
          handleDate(tomorrow);
          setStart(nextdayStoreOpen);
          handleTime(moment(nextdayStoreOpen, "HH:mm").diff(moment().startOf("day"), "seconds"));
        }
      }
    }
  }, [isCater, nextdayStoreOpen]);
  useEffect(function () {
    var momentDay = moment(date).format("YYYY-MM-DD");
    var comparison = formattedToday === momentDay;

    if (comparison && momentDay) {
      if (moment(nowPlus30, ['HH:mm']).isBefore(moment(storeOpen, ['HH:mm']))) {
        setStart(storeOpen);
        handleTime(moment(storeOpen, 'HH:mm').diff(moment().startOf('day'), 'seconds'));
      } else {
        setStart(nowPlus30);
        handleTime(moment(nowPlus30, 'HH:mm').diff(moment().startOf('day'), 'seconds'));
      }
    } else {
      var defaultStart = nextdayStoreOpen;
      setStart(defaultStart);
      handleTime(moment(defaultStart, 'HH:mm').diff(moment().startOf('day'), 'seconds'));
    }

    var locationName = title === "Catering" ? location === null || location === void 0 ? void 0 : location.olo_catering_unique_name : location === null || location === void 0 ? void 0 : location.olo_unique_name;

    if (moment(date).isValid()) {
      operations.getExcludedTimes(locationName, momentDay.split("-").join("")).then(function (res) {
        var excludes = res.map(function (el) {
          return moment(el, "HHmm").format("hh:mm A");
        });
        setExclude(excludes);
      });
    }
  }, [date]);

  var handleDate = function handleDate(e) {
    try {
      if (e == null) {
        setFieldValue(objName + "Date", undefined);
        setDate("");
      } else {
        var v = moment(e).format("YYYY-MM-DD");
        setFieldValue(objName + "Date", v);
        setDate(e);
        setStart("");
      }
    } catch (error) {
      console.error("handle date", error);
    }
  };

  var handleTime = function handleTime(e) {
    try {
      if (typeof (e === null || e === void 0 ? void 0 : e.getMonth) === "function") {
        var seconds = moment(e).diff(moment().startOf("day"), "seconds");
        setFieldValue(objName + "DueTime", seconds);
        setDueTime(seconds);
      } else {
        if (e) {
          setFieldValue(objName + "DueTime", e);
          setDueTime(e); // setStart('')
        } else {
          setFieldValue(objName + "DueTime", "");
          setDueTime("");
          setStart("");
        }
      }
    } catch (error) {
      console.error(error);
      setFieldValue(objName + "DueTime", "");
      setDueTime("");
    }
  };

  var getMinDefaultDate = function getMinDefaultDate(time) {
    // if storeOpen, and not within 20 min of closing, return today's date
    if (moment(time, ['HH:mm']).isSameOrBefore(moment(storeClose, ["h:mm A"]).subtract(21, 'minutes'))) {
      return moment();
    } else {
      // else return tomorrow's date
      return moment().add(1, 'day');
    }
  };

  var btnsAfterClose = function btnsAfterClose(time) {
    // if storeOpen, and not within 20 mins to closing, show both buttons
    if (time <= moment(storeClose, ["h:mm A"]).subtract(21, 'minutes').format("HH:mm") && time >= storeOpen) {
      return false;
    } else {
      // else only show scheduled button and disable ASAP button for eat
      return true;
    }
  };

  var name = title + "timingOptions";
  var svgdimenision = {
    width: "2em",
    height: "2em"
  };

  var forceOpenDateSelector = function forceOpenDateSelector(id) {
    document.getElementById(id).click();
  };

  var getIntervals = function getIntervals(start, end) {
    start.minutes(Math.ceil(start.minutes() / 15) * 15);
    var result = [];
    var current = moment(start);

    while (current <= end) {
      result.push(current.toDate());
      current.add(15, "minutes");
    }

    return result;
  };

  var filterOut = getIntervals(moment("00:00 AM", "hh:mm aa"), moment("07:00 AM", "hh:mm aa")).concat(getIntervals(moment("10:00 PM", "hh:mm aa"), moment("11:59 PM", "hh:mm aa")));

  var toggleStickyCartContinue = function toggleStickyCartContinue(displayValue) {
    var element = document.getElementById("mobileCartContinue");
    if (element) element.style.display = displayValue;
  };

  var handleCalendarOpen = function handleCalendarOpen() {
    toggleStickyCartContinue("none");
  };

  var handleCalendarClose = function handleCalendarClose() {
    toggleStickyCartContinue("unset");
  };

  var newFilters = exclude.map(function (time) {
    var today = moment(date).startOf('day');
    var timeAsMoment = moment(time, 'HH:mm a');
    var minutes = moment.duration(timeAsMoment.format('HH:mm')).asMinutes();
    var todayPlusMinutes = today.add(minutes, 'minute').toDate();
    return todayPlusMinutes;
  });
  return (
    /*#__PURE__*/
    // <fieldset className="cb-cart__travel-group"> USE IF WE REVERT BACK TO RADIOBUTTON
    React.createElement("fieldset", {
      className: "cb-cart__travel-options"
    }, /*#__PURE__*/React.createElement("legend", {
      className: "visuallyhidden"
    }, "Food Timing Options"), /*#__PURE__*/React.createElement(Row, null, !isCater && !btnsAfterClose(now) && /*#__PURE__*/React.createElement(Col, {
      className: "cb-no-padding cb-cart__travel-options__button-container"
    }, /*#__PURE__*/React.createElement(TravelButton, {
      title: "ASAP",
      name: name,
      onChange: handleOptionChange,
      selected: time,
      deliverytime: ""
    })), /*#__PURE__*/React.createElement(Col, {
      className: "cb-no-padding cb-cart__travel-options__button-container"
    }, /*#__PURE__*/React.createElement(TravelButton, {
      title: "Scheduled",
      name: name,
      onChange: handleOptionChange,
      selected: time,
      deliverytime: ""
    }))), time === "scheduled" && /*#__PURE__*/React.createElement("div", {
      className: "datetime"
    }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      md: 6
    }, /*#__PURE__*/React.createElement("div", {
      className: "d-flex react-datepicker-shadow cb-cart__travel-options__datepicker"
    }, /*#__PURE__*/React.createElement("div", {
      className: "cb-cart__travel-options__datepicker__icon",
      style: {
        marginLeft: "25%",
        marginTop: "4px"
      }
    }, /*#__PURE__*/React.createElement(BiCalendarAlt, {
      className: "cb-color-blue-500 justify-content-center",
      size: "1.4em",
      onClick: function onClick() {
        return forceOpenDateSelector("dateSelector" + index);
      }
    })), /*#__PURE__*/React.createElement(DatePicker, {
      selected: date,
      onChange: handleDate,
      minDate: getMinDefaultDate(now).toDate(),
      id: "dateSelector" + index,
      placeholderText: "Select a date",
      todayButton: "Today",
      className: "cb-form__input form-control cb-cart__travel-options__datepicker__input"
    }), /*#__PURE__*/React.createElement("div", {
      className: "cb-cart__travel-options__datepicker__chevron",
      style: {
        marginTop: "4px",
        marginRight: "30px"
      }
    }, /*#__PURE__*/React.createElement(BiChevronDown, {
      className: "cb-color-brown-500",
      size: "1.8em",
      onClick: function onClick() {
        return forceOpenDateSelector("dateSelector" + index);
      }
    })))), /*#__PURE__*/React.createElement(MediaQuery, {
      maxWidth: 990
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        marginBottom: "25%"
      }
    })), (!!date || true) && /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("div", {
      className: "d-flex react-datepicker-shadow cb-cart__travel-options__datepicker"
    }, /*#__PURE__*/React.createElement("div", {
      className: "cb-cart__travel-options__datepicker__icon",
      style: {
        marginLeft: "30%",
        marginTop: "4px"
      }
    }, /*#__PURE__*/React.createElement(AiOutlineClockCircle, {
      className: "cb-color-blue-500 justify-content-center",
      size: "1.4em",
      onClick: function onClick() {
        return forceOpenDateSelector("timeSelector" + index);
      }
    })), /*#__PURE__*/React.createElement(DatePicker, {
      selected: dueTime ? moment().startOf("day").add(dueTime, "seconds").toDate() : undefined // selected={moment().startOf('day').add(dueTime,'seconds').toDate()}
      ,
      onChange: handleTime,
      showTimeSelect: true,
      showTimeSelectOnly: true,
      timeIntervals: 15,
      timeCaption: "Time",
      dateFormat: "hh:mm aa",
      minTime: moment(start, "HH:mm").toDate(),
      maxTime: moment("22:00", "HH:mm").toDate(),
      id: "timeSelector" + index,
      placeholderText: "Select a time" //Will need id
      ,
      className: "cb-form__input form-control cb-cart__travel-options__datepicker__input",
      onCalendarClose: handleCalendarClose,
      onCalendarOpen: handleCalendarOpen,
      excludeTimes: filterOut.concat(newFilters)
    }), /*#__PURE__*/React.createElement("div", {
      className: "cb-cart__travel-options__datepicker__chevron",
      style: {
        marginTop: "4px",
        marginRight: "30px"
      }
    }, /*#__PURE__*/React.createElement(BiChevronDown, {
      className: "cb-color-brown-500",
      size: "1.8em",
      onClick: function onClick() {
        return forceOpenDateSelector("timeSelector" + index);
      }
    }))))), showLeadtimeErr && leadtimeErr !== "" && /*#__PURE__*/React.createElement(Row, {
      className: "leadtime-error-container"
    }, /*#__PURE__*/React.createElement(Col, {
      sm: "1"
    }, /*#__PURE__*/React.createElement("span", {
      className: "leadtime-error-logo"
    }, /*#__PURE__*/React.createElement("img", {
      src: leadtimeVectorImg,
      alt: "error-leadtime"
    }))), /*#__PURE__*/React.createElement(Col, {
      sm: "10"
    }, /*#__PURE__*/React.createElement("div", {
      className: "leadtime-text-container"
    }, leadtimeErr === null || leadtimeErr === void 0 ? void 0 : leadtimeErr.map(function (leadtimeErrTxt) {
      return /*#__PURE__*/React.createElement("p", {
        className: "leadtime-error"
      }, leadtimeErrTxt);
    }))))))
  );
};